import { GET, POST, PUT, DELETE, PATCH, EXPORT } from './http'

/**********         数据源管理 start    ****************/


/**********         用户登录 start    ****************/
/** 登录 */
export const login = (params) => POST('/api/cms/login/zxjy/staff', params)

export const auth = {
  login : (params) => POST('/api/cms/login/zxjy/staff', params),

  getQiniuToken : () => GET('/api/cms/login/qiniu'),
  //修改密码
  modifyPassword : (params) => PATCH('/api/cms/zxjy/staff', params)
}

//员工操作接口
export const staff = {
  //模拟员工登录
  login : (params) => POST('/api/cms/manager/login/zxjy/staff', params),
  //新增员工信息
  addStaff : (params) => POST('/api/cms/zxjy/staff/add', params),
  //查询员工信息
  queryAll : (params) => POST('/api/cms/zxjy/staff/query', params),
  //密码员工重置
  resetPassword : (id) => PATCH('/api/cms/zxjy/staff/password/' + id),
  //启用或停用员工信息
  delete : (ids) => POST('/api/cms/zxjy/staff/delete', ids),
  //启用或停用员工信息
  updateStaffInfo : (params) => POST('/api/cms/zxjy/staff/update', params)
}

//会员操作接口
export const user = {
  //查询会员信息
  query : (params) => POST('/api/cms/zxjy/user', params),
  //会员权限授权
  authProject : (params) => PUT('/api/cms/zxjy/user/vip', params),
  //导出数据信息
  exportUserInfo : (params, filename) => EXPORT('/api/cms/zxjy/user/export', params, filename),
  //删除用户信息
  deleteUserInfo : (params) => POST('/api/cms/zxjy/user/delete', params),
}

//科目操作接口
export const project = {
  //获取可以做授权的科目
  // queryConsult : () => GET('/api/cms/zxjy/project/consult'),
  //获取最父级的科目
  queryParent : () => GET('/api/cms/zxjy/project/list/parent'),
  //获取最父级的科目
  getAllProject : () => GET('/api/cms/zxjy/project/list/getAllProject'),
  //获取所有根节点的项目
  // queryLeaf : () => GET('/api/cms/zxjy/project/leaf'),
  //更新科目中的跳转地址
  updateJumpUrl : (params) => PATCH('/api/cms/zxjy/project/url', params),
  //更新科目中的跳转地址或者文件预览地址
  getViewUrl : (id) => GET('/api/cms/zxjy/project/' + id),
  //更新科目中的跳转地址或者文件预览地址
  // viewPdf : (id) => GET('/api/cms/zxjy/project/view/' + id),
  //更新科目中的跳转地址或者文件预览地址
  // viewVideo : (params) => POST('/api/cms/login/getViewUrl', params),
  //更新科目中的跳转地址或者文件预览地址
  uploadAnswerPhonto : (params) => POST('/api/cms/zxjy/project/uploadAnswerUrl', params),
  //更新科目中咨询号码
  updatePhoneNum : (id, phoneNum) => PATCH('/api/cms/zxjy/project/' + id + "/" + phoneNum),
}

//题目操作接口
export const subject = {
  //查询
  findSubject : (projectId, params) => POST('/api/cms/zxjy/subject/query/' + projectId, params),
  //新增
  addSubject : (params) => POST('/api/cms/zxjy/subject', params),
  //修改
  modifySubject : (params) => PATCH('/api/cms/zxjy/subject', params),
  //删除
  deleteSubject : (id) => DELETE('/api/cms/zxjy/subject/' + id),
  //删除
  delete : (params) => POST('/api/cms/zxjy/subject/delete', params),
}

//咨询信息操作接口
export const consult = {
  //查询咨询信息
  findConsult : (params) => POST('/api/cms/zxjy/conslut/query' , params),
  //修改咨询信息装填
  // updateStatus : (id) => PATCH('/api/cms/zxjy/conslut/' + id),
  //修改咨询信息装填
  updateInfo : (params) => PATCH('/api/cms/zxjy/conslut', params),
  //查询咨询电话
  // queryConsultNum : () => GET('/api/cms/zxjy/conslut'),
  //设置咨询电话
  // updateConsultNum : (params) => PATCH('/api/cms/zxjy/conslut', params),
  //删除咨询信息
  delete : (params) => POST('/api/cms/zxjy/conslut/delete', params),
}

